
export const LogoPath = './assets/media/logos/maven-practice-app.svg';

export const UserimgPath = './assets/media/users/';
export const EditIconPath = './assets/media/svg/icons/Communication/Write.svg';
export const CloseIconPath = './assets/media/svg/icons/Navigation/Close.svg';
export const UserIconPath = './assets/media/svg/icons/General/User.svg';
export const PwdIconPath = './assets/media/svg/icons/General/Shield-protected.svg';
export const TwofaIconPath = './assets/media/svg/icons/General/Shield-protected.svg';
export const HospitalGroupPath = './assets/media/svg/icons/a2z/hospital_gp.svg';
export const HospitalPath = './assets/media/svg/icons/a2z/hospital.svg';
export const ContractIconPath = './assets/media/svg/icons/a2z/contract.svg';
export const ProviderGroupPath = './assets/media/svg/icons/a2z/doctor_group.svg';

